import { API_ERROR_CODES } from '../../../constants';
import OpenAPIClientAxios from 'openapi-client-axios';

let nedglobeApiSpec;
let nedglobeApi;
let nedglobeApiInstance;
let currentToken;

async function getNedglobeApiSpec( store ) {
    if (!nedglobeApiSpec) {
        const nedglobeApiSpecResult = await store.dispatch('getData', { url: '/swagger.json', endpoint: '/swagger/v1/' });
        nedglobeApiSpec = nedglobeApiSpecResult.data;
    }
    return nedglobeApiSpec;
}

export async function getNedglobeApi( store ) {
    if (!nedglobeApi || currentToken !== store.state.accessToken) {
        await getNedglobeApiSpec(store);
        currentToken = store.state.accessToken;
        const axiosConfigDefaults = currentToken ? { headers: { common: { Authorization: `Bearer ${currentToken}` } } } : {};
        const createdApi = new OpenAPIClientAxios({ definition: nedglobeApiSpec, axiosConfigDefaults });
        nedglobeApi = createdApi;
    }
    return nedglobeApi;
}

async function getNedglobeApiInstance( store ) {
    await getNedglobeApi( store );
    const instance = await nedglobeApi.init();
    instance.interceptors.response.use(
        response => response,
        async error => {
            const originalRequest = error.config;
            const { status } = error.response;
            if (status === API_ERROR_CODES.unauthorized && !originalRequest._retry) {
                originalRequest._retry = true;
                currentToken = await store.dispatch('refreshLoginToken');
                originalRequest.headers['Authorization'] = `Bearer ${currentToken}`;
                return instance(originalRequest);
            }
            return Promise.reject(error);
        }
    );
    return nedglobeApi.getClient();
}

const api = (store) => {
    if (nedglobeApiInstance && currentToken === store.state.accessToken) {
        return nedglobeApiInstance;
    }
    nedglobeApiInstance = getNedglobeApiInstance( store );
    return nedglobeApiInstance;
};

export default api;
